import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'initials',
  standalone: true,
})
export class InitialsPipe implements PipeTransform {
  transform(name: string, maxLength: number = 2): string {
    if (!name) return '';

    const ignored = ['de', 'da', 'do', 'das', 'dos', 'e','pe.', 'sr.', 'sra.', 'srta.', 'srta'];

    return name
      .split(' ')
      .filter(word => !ignored.includes(word.toLowerCase()))
      .map(word => word.charAt(0))
      .join('')
      .slice(0, maxLength)
      .toUpperCase();
  }
}
